/**
 * KAN-735: Firebase emulator hook. In every real build (development, staging, production) this file is a no-op, so no
 * emulator code path ships. Only the `e2e-emulator` Angular configuration swaps it for firebase-emulators.e2e.ts.
 */
import type { FirebaseApp } from '@angular/fire/app';
import type { AppConfig } from './services/config.service';

/** Local app config used instead of the remote config endpoint; null outside the e2e-emulator build. */
export const EMULATOR_APP_CONFIG: AppConfig | null = null;

export function connectFirebaseEmulators(_app: FirebaseApp): void {}
